export const getUserOperationReceipt = async (client, args) => {
    return client.request({
        method: "eth_getUserOperationReceipt",
        params: [args.hash],
    });
};
//# sourceMappingURL=getUserOperationReceipt.js.map